import React from 'react';
import { Button, Icon, Tooltip, Upload as AntdUpload } from '@whalecloud/fdx';
// import { Upload as AntdUpload } from 'antd'; // 用fdx的Upload会出现一次下载两次文件的问题，所以这里换成antd的Upload
import { get } from 'lodash';
import { getBusinessI18n } from '@/utils';
import styles from './index.less';

export default function Upload(props) {
  const { requiredRule } = props;
  return (
    <AntdUpload {...props} className={styles.upload}>
      <Button>
        <Icon type="upload" />{getBusinessI18n('UPLOAD')}
      </Button>
      {!props.disabled && (
        <Tooltip
          overlayClassName={styles.tooltip}
          title={<div>Required File Size: &lt; {get(requiredRule, 'size')}KB <br />Required File Type: {get(requiredRule, 'typeList').join(', ')}</div>}
          onClick={e => e.stopPropagation()}
        >
          <Icon type="info-circle" />
        </Tooltip>
      )}
    </AntdUpload>
  );
}
